<template>
  <section v-if="$beet.destinations" class="section swiper-voyage">
    <h2 class="section__title" v-reveal>
      {{ title }}
    </h2>

    <p class="swiper-voyage__subtitle" v-reveal>
      {{ description }}
    </p>

    <LangRouterLink :to="{ name: 'voyages' }" class="button -light -right section__button" v-reveal>
      <span>
        {{ explore_btn ?? $t('trips.explore') }}
      </span>

      <div class="button__icon">
        <Icon id="arrow" />
      </div>
    </LangRouterLink>

    <Swiper
      ref="swiper-voyage"
      key="swiper-voyage"
      :modules="swiper.modules"
      :pagination="swiper.pagination"
      :slides-per-view="mq.lgPlus ? 3 : mq.mdPlus ? 2 : 1"
      :space-between="16"
      class="swiper-voyage__swiper swiper1 swipe"
    >
      <SwiperSlide v-for="(item, key) in destinations" :key="`card-${key}`">
        <VoyageCard
          :voyage="Object.values($beet.destinations).find(({ id }) => id === Number(item))"
          class="-swiper"
        />
      </SwiperSlide>

      <SectionSwiperControls :items-count="destinations.length" larger voyage />
    </Swiper>
  </section>
</template>

<script>
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/vue'

import SectionSwiperControls from '@/components/blocks/SectionSwiperControls.vue'
import VoyageCard from '@/components/cards/VoyageCard.vue'
import Icon from '@/components/global/Icon.vue'
import LangRouterLink from '@/components/global/LangRouterLink.vue'

export default {
  name: 'SectionSwiperVoyages',

  inject: ['mq'],

  components: {
    Icon,
    LangRouterLink,
    SectionSwiperControls,
    Swiper,
    SwiperSlide,
    VoyageCard,
  },

  props: {
    bg_color: {
      type: String,
      default: 'blue',
    },

    title: {
      type: String,
      default: 'Title',
    },

    description: {
      type: String,
      default: 'Text',
    },

    explore_btn: {
      type: String,
      default: null,
    },

    destinations: {
      type: Array,
      default: () => ['1', '2', '3'],
    },
  },

  data() {
    return {
      swiper: {
        modules: [Pagination],
        slideToClickedSlide: true,
        grabCursor: true,

        pagination: {
          clickable: true,
          horizontalClass: 'swipe-horizontal',
          bulletClass: 'swipe-bullet',
          bulletActiveClass: 'swipe-bullet-active',
        },
      },
    }
  },
}
</script>
